let vTextNodes = []

const getTextWrapNode = el => {
  let targetNode = el
  while(!targetNode.dataset || !targetNode.dataset.id && targetNode.tagName !== 'BODY') {
    targetNode = targetNode.parentNode
  }
  if(targetNode.tagName === 'BODY') return null
  return targetNode
}

export function initVTextNodes(textNodes) {
  let offset = 0
  let relativeOffset = 0
  vTextNodes = []
  let lastTextNodeId = ''
  for(let i = 0; i < textNodes.length; i++) {
    const text = textNodes[i]

    const textWrapNode = getTextWrapNode(text)
    const textNodeId = textWrapNode.dataset.id
    if(textWrapNode) {
      if(lastTextNodeId !== textNodeId) {
        relativeOffset = 0
      }
      lastTextNodeId = textNodeId
    }
    vTextNodes.push({
      text,
      ignore: text.ignore || false,
      offset: text.ignore ? -1 : offset,
      relativeOffset: text.ignore ? -1 : relativeOffset,
      nodeId: textNodeId,
    })
    if(!text.ignore) {
      offset += text.textContent ? text.textContent.length : 0
      relativeOffset += text.textContent ? text.textContent.length : 0
    }
  }
}

export function splitVTextNode(text, offset) {
  const i = vTextNodes.findIndex(item => item.text === text)
  if(i !== -1) {
    const newText = vTextNodes[i].text.splitText(offset)
    const newVText = {
      text: newText,
      ignore: vTextNodes[i].ignore,
      nodeId: vTextNodes[i].nodeId,
      offset: vTextNodes[i].offset + (vTextNodes[i].text.textContent?.length || 0),
      relativeOffset: vTextNodes[i].relativeOffset + (vTextNodes[i].text.textContent?.length || 0),
    }
    vTextNodes.splice(i + 1, 0, newVText)
    return newVText
  }
}

export function sliceVTextNode(startText, endText, hasIgnore = false) {
  const startIndex = vTextNodes.findIndex(item => item.text === startText.text)
  const endIndex = vTextNodes.findIndex(item => item.text === endText.text)
  if(startIndex !== -1 && endIndex !== -1) {
    let rangeTextNodes = vTextNodes.slice(startIndex, endIndex)
    rangeTextNodes = hasIgnore ? rangeTextNodes.filter(item => !item.ignore) : rangeTextNodes
    return rangeTextNodes.map(item => item.text)
  }
}

export function getTextContainerForRelativeOffset(nodeId, relativeOffset) {
  const nodes = vTextNodes.filter(item => !item.ignore)
  const i = nodes.findIndex(item => {
    return item.nodeId === nodeId && item.relativeOffset + item.text.length >= relativeOffset
  })
  if(i !== -1) return nodes[i]
}

export function getOptionalVText(vTextNode) {
  let i = vTextNodes.findIndex(item => item === vTextNode)
  if(i !== -1) {
    i = i === 0 ? 0 : i - 1
    while(i !== 0) {
      if(!vTextNodes[i].ignore) {
        return vTextNodes[i + 1]
      }
      i--
    }
  }
}